'use client';

import './css/callToAction.css';
import { TTourParams } from '@/types';
import { months } from '@/config/constants';
import Image from 'next/image';
import { people } from 'public/static/icons';
import { RepeatIcon } from '../icons';

interface ICallToAction {
  handleClick: () => void;
  tourParams: TTourParams;
}

export const CallToActionSelected = ({ handleClick, tourParams }: ICallToAction) => {
  const month = months.find((month) => month.value === tourParams.month);
  if (!month) return null;
  const adultsPlural = tourParams.adults % 10 === 1 ? 'Adult' : 'Adults';
  const childrenPlural = tourParams.children % 10 === 1 ? 'Child' : 'Children';

  return (
    <div className="tour-cta__inner tour-cta__inner__complete text-white bg-gray-900">
      <div className="flex flex-col gap-5">
        <span className="text-md text-gray-500">Select the tour for:</span>
        <div className="flex flex-col gap-1">
          <h3 className="text-xl font-rokkitt">
            {month.label} {tourParams.day + 1}, {tourParams.year}
          </h3>
          <div className="flex flex-row gap-2 text-md font-light">
            <Image src={people} alt="people" />
            <span>Visitors:</span>
            <span>
              {tourParams.adults} {adultsPlural}
            </span>
            <span className="font-bold">·</span>
            <span>
              {tourParams.children} {childrenPlural}
            </span>
          </div>
        </div>
      </div>
      <button className="flex flex-row gap-2 items-center bg-transparent" onClick={handleClick}>
        <RepeatIcon />
        <span className="text-md font-semibold text-primary-500 font-inter">Change</span>
      </button>
    </div>
  );
};
